import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import Hero from '@/sections/Hero';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { SectionHeadline } from '@/components/SectionHeadline';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { Trans, useTranslation } from 'react-i18next';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import React from 'react';
import { Link } from '@/components/links';
import { DXHeroes } from '@/sections/forEshops/DXHeroes';
import { Integration } from '@/sections/forEshops/Integration';
import { DXHeroesBubble } from '@/sections/forEshops/DXHeroesBubble';
import { ContactForm } from '@/sections/forEshops/ContactForm';
import { FAQs } from '@/components/seo';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { SeoHeader } from '@/components/SeoHeader';
import { Text } from '@/components/typography';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { getSectionAnchorId } from '@/utils/anchors';
interface Props extends IntlProps {
  pageBanner: PageBanner | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(111);
  const {
    pageBanner,
    menuPromoBanners
  } = t0;
  usePageView("forDevelopers");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["forDevelopers", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = pageBanner?.videoId;
  let t6;
  if ($[8] !== pageBanner?.title || $[9] !== t) {
    t6 = pageBanner?.title ?? t("banner.title");
    $[8] = pageBanner?.title;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== pageBanner?.text || $[12] !== t) {
    t7 = pageBanner?.text ?? t("banner.text");
    $[11] = pageBanner?.text;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== pageBanner || $[15] !== t) {
    t8 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("banner.cta.1"),
      label: t("banner.cta.1"),
      to: EXTERNAL_LINKS().developersPortal,
      testId: "forDevelopersHeroPrimaryCTA",
      analyticsParam: "forDevelopersHeroPrimaryCTA",
      variant: "primary"
    }, {
      ariaLabel: t("banner.cta.2"),
      label: t("banner.cta.2"),
      to: LINKS().allProducts,
      testId: "forDevelopersHeroSecondaryCTA",
      analyticsParam: "forDevelopersHeroSecondaryCTA",
      variant: "secondary"
    }];
    $[14] = pageBanner;
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = pageBanner?.image?.url ?? "/images/sections/forDevelopers/hero/hero.png";
  let t10;
  if ($[17] !== pageBanner?.image?.alt || $[18] !== t) {
    t10 = pageBanner?.image?.alt ?? t("banner.title");
    $[17] = pageBanner?.image?.alt;
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = {
      url: t9,
      alt: t10
    };
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = pageBanner?.variant || "mockupDesktop";
  let t13;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t13 = <Hero videoId={t5} title={t6} text={t7} buttons={t8} image={t11} variant={t12} />;
    $[23] = t11;
    $[24] = t12;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-900" background="bg-transparent" /></div>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = getSectionAnchorId("weAreLeaders");
    t16 = <DXHeroesBubble />;
    $[31] = t15;
    $[32] = t16;
  } else {
    t15 = $[31];
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t("weAreLeaders.title");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17) {
    t18 = <div className="relative mx-auto mb-5 max-w-157" id={t15}>{t16}<SectionHeadline variant="inverted" className="px-0" anchorKey="weAreLeaders.title">{t17}</SectionHeadline></div>;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("weAreLeaders.text");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19) {
    t20 = <Text className="text-light-gray-100 mx-auto max-w-192 text-center">{t19}</Text>;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="py-14 lg:py-20"><DXHeroes /></div>;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = getSectionAnchorId("aboutDevPortal");
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t) {
    t23 = t("aboutDevPortal.title");
    $[43] = t;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t23) {
    t24 = <SectionHeadline variant="inverted" className="px-0" anchorKey="aboutDevPortal.title">{t23}</SectionHeadline>;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="mx-auto mt-10 max-w-[60rem] overflow-hidden rounded-2xl lg:mt-16 lg:rounded-4xl"><div className="aspect-video"><iframe className="h-full w-full" src="https://www.youtube.com/embed/so2wDcx6WaA" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen={true} loading="lazy" /></div></div>;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t24) {
    t26 = <div className="pt-14 lg:pt-20" id={t22}>{t24}{t25}</div>;
    $[48] = t24;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t18 || $[51] !== t20 || $[52] !== t26) {
    t27 = <div className="relative z-30 bg-blue-900 pt-10 pb-20 lg:pt-20 lg:pb-40"><div className="relative z-10 px-4">{t18}{t20}{t21}{t26}</div></div>;
    $[50] = t18;
    $[51] = t20;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t13 || $[55] !== t27) {
    t28 = <div className="relative overflow-x-hidden">{t13}{t14}{t27}</div>;
    $[54] = t13;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <SectionDelimiter color="bg-blue-100" background="bg-blue-900" />;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  let t31;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="relative bg-blue-100 px-4 py-10 pb-20 lg:py-20 lg:pb-40"><Integration /></div>;
    t31 = <SectionDelimiter color="bg-blue-700" background="bg-blue-100" />;
    $[58] = t30;
    $[59] = t31;
  } else {
    t30 = $[58];
    t31 = $[59];
  }
  let t32;
  if ($[60] !== t) {
    t32 = t("faq.title");
    $[60] = t;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== t32) {
    t33 = <SectionHeadline className="mb-10 px-0 lg:mb-16" variant="inverted" id="faq">{t32}</SectionHeadline>;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== t) {
    t34 = t("faq.items.1.title");
    $[64] = t;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Link testId="developersPortal" analyticsParam="developersPortal" to={EXTERNAL_LINKS().developersPortal} />;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Link testId="developersPortalAPI" analyticsParam="developersPortalAPI" to={EXTERNAL_LINKS().developersPortalAPI} />;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] !== t) {
    t37 = <Trans t={t} i18nKey="faq.items.1.text">{t35}{t36}</Trans>;
    $[68] = t;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t34 || $[71] !== t37) {
    t38 = {
      question: t34,
      answer: t37
    };
    $[70] = t34;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t) {
    t39 = t("faq.items.2.title");
    $[73] = t;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] !== t) {
    t40 = t("faq.items.2.text");
    $[75] = t;
    $[76] = t40;
  } else {
    t40 = $[76];
  }
  let t41;
  if ($[77] !== t39 || $[78] !== t40) {
    t41 = {
      question: t39,
      answer: t40
    };
    $[77] = t39;
    $[78] = t40;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  let t42;
  if ($[80] !== t) {
    t42 = t("faq.items.3.title");
    $[80] = t;
    $[81] = t42;
  } else {
    t42 = $[81];
  }
  let t43;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Link testId="developersPortalGuides" analyticsParam="developersPortalGuides" to={EXTERNAL_LINKS().developersPortalGuides} />;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  let t44;
  if ($[83] !== t) {
    t44 = <Trans t={t} i18nKey="faq.items.3.text">{t43}</Trans>;
    $[83] = t;
    $[84] = t44;
  } else {
    t44 = $[84];
  }
  let t45;
  if ($[85] !== t42 || $[86] !== t44) {
    t45 = {
      question: t42,
      answer: t44
    };
    $[85] = t42;
    $[86] = t44;
    $[87] = t45;
  } else {
    t45 = $[87];
  }
  let t46;
  if ($[88] !== t38 || $[89] !== t41 || $[90] !== t45) {
    t46 = <FAQs hideButton={true} className="m-0!" bgColor="bg-blue-100" data={[t38, t41, t45]} />;
    $[88] = t38;
    $[89] = t41;
    $[90] = t45;
    $[91] = t46;
  } else {
    t46 = $[91];
  }
  let t47;
  if ($[92] !== t33 || $[93] !== t46) {
    t47 = <div className="mx-auto max-w-192 py-10 lg:py-20">{t33}{t46}</div>;
    $[92] = t33;
    $[93] = t46;
    $[94] = t47;
  } else {
    t47 = $[94];
  }
  let t48;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = getSectionAnchorId("form");
    $[95] = t48;
  } else {
    t48 = $[95];
  }
  let t49;
  if ($[96] !== t) {
    t49 = t("form.title");
    $[96] = t;
    $[97] = t49;
  } else {
    t49 = $[97];
  }
  let t50;
  if ($[98] !== t49) {
    t50 = <SectionHeadline className="mb-10 lg:mb-16" variant="inverted" anchorKey="form.title">{t49}</SectionHeadline>;
    $[98] = t49;
    $[99] = t50;
  } else {
    t50 = $[99];
  }
  let t51;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <ContactForm variant="forDevelopers" />;
    $[100] = t51;
  } else {
    t51 = $[100];
  }
  let t52;
  if ($[101] !== t50) {
    t52 = <div className="mx-auto max-w-192 pt-10 pb-20 lg:pt-20 lg:pb-40" id={t48}>{t50}{t51}</div>;
    $[101] = t50;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] !== t47 || $[104] !== t52) {
    t53 = <div className="relative overflow-hidden bg-blue-700 px-4">{t47}{t52}</div>;
    $[103] = t47;
    $[104] = t52;
    $[105] = t53;
  } else {
    t53 = $[105];
  }
  let t54;
  if ($[106] !== menuPromoBanners || $[107] !== t28 || $[108] !== t4 || $[109] !== t53) {
    t54 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t28}{t29}{t30}{t31}{t53}</Layout>;
    $[106] = menuPromoBanners;
    $[107] = t28;
    $[108] = t4;
    $[109] = t53;
    $[110] = t54;
  } else {
    t54 = $[110];
  }
  return t54;
}
export const getStaticProps = (async ctx => {
  return {
    props: {
      pageBanner: await getPageBannerBySlug('for-developers'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'forEshops', 'forDevelopers']))
    }
  };
}) satisfies GetStaticProps<Props>;